import * as React from 'react';

import * as styles from './FavoriteButton.css';

export interface IFavoriteButtonProps {
  favoriteButton: React.ReactNode;
  pushSubscription: React.ReactNode;
  loginMotivation: React.ReactNode;
}

export class FavoriteButton extends React.PureComponent<IFavoriteButtonProps> {
  public render() {
    const { favoriteButton, pushSubscription, loginMotivation } = this.props;

    return (
      <span className={styles['container']}>
        <div>{favoriteButton}</div>
        {pushSubscription}
        {loginMotivation}
      </span>
    );
  }
}
